import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Model from 'flarum/common/Model';
export default class Vote extends Model {
  constructor() {
    super(...arguments);
    _defineProperty(this, "createdAt", Model.attribute('createdAt', Model.transformDate));
    // Direct attribute access for IDs (for when relationships aren't loaded)
    _defineProperty(this, "nomineeId", Model.attribute('nomineeId'));
    _defineProperty(this, "categoryId", Model.attribute('categoryId'));
    _defineProperty(this, "userId", Model.attribute('userId'));
    // Relationship accessors
    _defineProperty(this, "nominee", Model.hasOne('nominee'));
    _defineProperty(this, "category", Model.hasOne('category'));
    _defineProperty(this, "user", Model.hasOne('user'));
  }
}
flarum.reg.add('huseyinfiliz-awards', 'common/models/Vote', Vote);